import React from 'react';
import {createBrowserHistory} from 'history';

import {BrowserRouter as Router, NavLink, Redirect, Route, Switch} from 'react-router-dom';
import Home from '../components/Home';
import Login from '../components/Login';
import Register from '../components/Register';
import SubmitAdd from '../components/submitadd';
import List from '../components/List';
import Account from '../components/account';
import SingleProduct from '../components/singleProducet';
import Layout from "../components/shared/Layout";
import {connect} from "react-redux";
import PartnerPage from "../Pages/PartnerPage";
import Cookie from "../components/Cookie/Cookie";

const history = createBrowserHistory();
const NotFound = () => {
    return (
        <div className="container p-5">
            <h4>The page you are requested is not found. Error:404</h4>
            <NavLink to="\">Goto Home</NavLink>
        </div>
    );
}

class Routes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cookieAgreed: false
        }
    }

    componentWillMount() {
        let cookieAgreed = localStorage.getItem('cookieAgreed');
        this.setState({cookieAgreed: cookieAgreed ? cookieAgreed : false})
    }

    render() {
        console.log('this', this.props.store)
        return (
            <Router history={history}>
                <React.Fragment>
                    <Switch>
                        <Route exact path='/' render={() => (
                            <Layout>
                                <Home/>
                            </Layout>
                        )}/>
                        <Route exact path='/user/login' render={() => (
                            <Layout>
                                <Login/>
                            </Layout>
                        )}/>
                        <Route exact path='/user/register' render={() => (
                            <Layout>
                                <Register/>
                            </Layout>
                        )}/>
                        <Route exact path='/posting' render={() => (
                            <Layout>
                                <SubmitAdd/>
                            </Layout>
                        )}/>
                        <Route exact path='/myaccount' render={() => (
                            <Layout>
                                <Account/>
                            </Layout>
                        )}/>
                        <Route exact path='/:productId/item/:id' render={() => (
                            <Layout>
                                <SingleProduct/>
                            </Layout>
                        )}/>
                        {/*<Route exact path='/item/:id' render={() => (*/}
                        {/*    <Redirect to={'/:productId/item/:id'}/>*/}

                        {/*)}/>*/}
                        <Route exact path='/:category/listing' render={() => (
                            <Layout>
                                <List/>
                            </Layout>
                        )}/>
                        {/*<Route exact path='/list/:category' render={() => (*/}
                        {/*    <Redirect to={'/:category/listing'}/>*/}

                        {/*)}/>*/}
                        <Route exact path='/cities/:city' render={() => (
                            <Layout>
                                <List/>
                            </Layout>
                        )}/>
                        <Route exact path='/become-partner' render={() => (
                            <Layout>
                                <PartnerPage/>
                            </Layout>
                        )}/>
                        {/*<Route exact path='*' render={() => (*/}
                        {/*    <Layout>*/}
                        {/*        <NotFound/>*/}
                        {/*    </Layout>*/}
                        {/*)}/>*/}
                        <Route exact path='*' render={() => (
                            <Redirect to={'/become-partner'}/>

                        )}/>
                        {/*<Header/>*/}
                        {/*<Footer/>*/}
                    </Switch>
                    {!this.state.cookieAgreed && <Cookie cookieAccepted={() => {
                        this.setState({cookieAgreed: true})
                    }}/>}
                </React.Fragment>
            </Router>


        );
    }
}

export default connect()(Routes);




// WEBPACK FOOTER //
// ./src/config/Routes.js